
import axios from '@/axios.js'

export default {

  getUserLessons({commit, state}, uuid) {
    if (state.userLessons.length > 0) return
    return new Promise((resolve, reject) => {
      axios.get(`/lessons/${uuid}`)
        .then((response) => {
          commit('ADD_USER_LESSONS', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
